import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  readonly fastTrack: boolean = environment.features.fastTrack;
}
